import React from 'react';
import PropTypes from 'prop-types';

import MartyLink from 'components/common/MartyLink';
import styles from 'styles/components/account/subscriptions/stockSubscriptionListItem.scss';
import { constructMSAImageUrl } from 'helpers';

const THUMBNAIL_WIDTH_PIXELS = 136;
const THUMBNAIL_HEIGHT_PIXELS = 102;

const msaImageDimensions = { width: THUMBNAIL_WIDTH_PIXELS * 2, height: THUMBNAIL_HEIGHT_PIXELS * 2 };

const StockSubscriptionListItem = ({ productName, asin, brand, color, size, width, imageId, subscribed, onStockChange }) => {
  const imageUrl = constructMSAImageUrl(imageId, msaImageDimensions);

  return (
    <tr>
      <td>
        <div className={styles.wrapper}>
          <div className={styles.checkboxContainer}>
            <input
              name={productName}
              id={asin}
              checked={subscribed}
              onChange={onStockChange}
              value={asin}
              type="checkbox"/>
          </div>
          <MartyLink
            to={`/p/asin/${asin}`}
            className={styles.mProduct}
            data-track-action="My-Favorites"
            data-track-label="Favorites-Product"
            data-track-value="Image-Clicked">
            <div className={styles.image}>
              <img src={imageUrl} alt={productName}/>
            </div>
          </MartyLink>
          <div className={styles.itemContainer}>
            <div>
              <MartyLink to={`/p/asin/${asin}`}>
                <div className={styles.productName}>{productName}</div>
              </MartyLink>
            </div>
            <div className={styles.itemDetails}>
              <div>ASIN: {asin}</div>
              <div>Brand: {brand}</div>
              <div>Color: {color}</div>
              {size &&
              <div>Size: {size}</div>
              }
              {width &&
              <div>Width: {width}</div>
              }
            </div>
          </div>
        </div>
      </td>
    </tr>
  );
};

StockSubscriptionListItem.propTypes = {
  productName: PropTypes.string.isRequired,
  asin: PropTypes.string.isRequired,
  brand: PropTypes.string.isRequired,
  imageId: PropTypes.string.isRequired,
  subscribed: PropTypes.bool.isRequired,
  onStockChange: PropTypes.func.isRequired
};

export default StockSubscriptionListItem;
